import type { ProductLogoMediumProps } from '../types';

export function ProductLogoMediumMyProfile({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 672 672"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="672" height="672" rx="100" fill="#1A2142" />
      <path
        d="M403.296 362.919C462.763 362.919 510.971 411.126 510.971 470.593V510.971C510.971 518.404 504.945 524.43 497.511 524.43H174.489C167.055 524.43 161.029 518.404 161.029 510.971V470.593C161.029 411.126 209.237 362.919 268.704 362.919H403.296Z"
        fill="#57D7D9"
      />
      <path
        d="M336 147.57C388.033 147.57 430.215 189.752 430.215 241.785C430.215 293.819 388.033 336 336 336C283.966 336 241.785 293.819 241.785 241.785C241.785 189.752 283.966 147.57 336 147.57Z"
        fill="#57D7D9"
      />
    </svg>
  );
}
